import requestFlow from '@/utils/requestFlow'
import { plaidItemsRoutine, PLAID_CLEANUP } from '@/store/modules/plaid/routines'

export default {
  ...requestFlow(plaidItemsRoutine).mockMutations,

  [plaidItemsRoutine.SUCCESS](state, payload) {
    const raw = payload?.items ?? payload ?? []
    state.plaidItems = raw.map(entry => entry?.item ?? entry).filter(Boolean)
  },

  [PLAID_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
